import PaginationWithData from './PaginationWithData';
import PaginationBoxView from './PaginationBoxView';

export {
    PaginationWithData,
    PaginationBoxView
}
export default PaginationBoxView;